import { UserState, CompanyState, SitesState } from './types'

export const initialUserState: UserState = {
    value: null,
    loading: false,
    error: null,
    isInit: false,
}

export const initialCompanyState: CompanyState = {
    value: null,
    loading: false,
    error: null,
}

export const initialSitesState: SitesState = {
    directory: null,
    gates: null,
    loading: false,
    error: null,
}
